module.exports = __webpack_public_path__ + "menu_0_pc.0c9e31ca.png";